// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'RENTAL';
export const RentalActionTypes = {
  RENTAL: ActionHelper.createActionTypes(actionTypePrefix, 'RENTAL'),
  RENTALFEATURE: ActionHelper.createActionTypes(
    actionTypePrefix,
    'RENTALFEATURE'
  ),
  RENTAL_DETAIL: ActionHelper.createActionTypes(
    actionTypePrefix,
    'RENTAL_DETAIL'
  ),
  RENTAL_FILTERS: {
    INITIALIZE: `${actionTypePrefix}/RENTAL_FILTERS_INITIALIZE`,
    TOGGLE_FILTER: `${actionTypePrefix}/RENTAL_FILTERS_TOGGLE_FILTER`,
    CLEAR_FILTERS: `${actionTypePrefix}/RENTAL_FILTERS_CLEAR_FILTERS`,
  },
  RENTAL_ADVERT: {
    SUCCESS: `${actionTypePrefix}/RENTAL_ADVERT_SUCCESS`,
  },
};
